import React from 'react';
import TableDataField from './TableDataField';

const CodeField = ({content}) => {
    return (
        <TableDataField extraStyling="col-small">
            {content}
        </TableDataField>
    );
};

export default CodeField;
